// libs
import { Routes, Route } from "react-router-dom";

// pages
import NotFoundPage from "./pages/NotFoundPage";
import HomePage from "./pages/HomePage";
import StatisticsPage from "./pages/StatisticsPage";
import ProfilePage from "./pages/ProfilePage";
import ActionsPage from "./pages/ActionsPage";
import ProductsPage from "./pages/ProductsPage";
import AuthPage from "./pages/AuthPage";

// components
import Alerts from "./components/Alerts";

// routes
import ROUTES from "./constants/routes.js";

// styles
import "./CSS/general.css";

function App() {
  return (
    <div>
      <Routes>
        <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />

        <Route path={ROUTES.HOME} element={<HomePage />}>
          <Route path={ROUTES.PRODUCTS} element={<ProductsPage />} />
          <Route path={ROUTES.ACTIONS} element={<ActionsPage />} />
          <Route path={ROUTES.STATISTICS} element={<StatisticsPage />} />
          <Route path={ROUTES.PROFILE} element={<ProfilePage />} />
        </Route>

        <Route path={ROUTES.AUTH} element={<AuthPage />} />
      </Routes>
      <Alerts />
    </div>
  );
}

export default App;
